import {Ref} from "vue";
import {loyaltyCardMembershipTransactionApi} from "@/container";
import useInfiniteLoading from "@/core/composables/swr/useInfiniteLoading";
import {cacheKey} from "@/lib/cache";
import {LoyaltyCardMembershipTransaction} from "@/loyalty-card/interfaces/hds/LoyaltyCard";

/**
 * Composable to fetch customer loyalty card membership transactions, page
 * after page ("Afficher plus"); changing the type starts the list over.
 *
 * @param customerId
 * @param membershipId
 * @param type
 */
const useCustomerLoyaltyCardMembershipTransactions = (customerId: number, membershipId: number, type: Ref<string | null>) => {
    const {data, isLoading, isLoadingMore, error, hasMore, loadMore, refresh} = useInfiniteLoading<LoyaltyCardMembershipTransaction>(
        () => cacheKey(`/customer/${customerId}/loyalty-card-memberships/${membershipId}/transactions`, {type: type.value}),
        async (page) => {
            const response = await loyaltyCardMembershipTransactionApi().get(customerId, membershipId, type.value, page);

            // The resource swallows a failed request into an empty array: surface
            // it, so a failure does not read as a card without history.
            if (!Array.isArray(response?.data)) {
                throw new Error("The loyalty card membership transactions could not be loaded.");
            }

            return response;
        }
    );

    return {
        transactions: data,
        isLoading,
        isLoadingMore,
        error,
        hasMore,
        loadMore,
        refresh
    };
};

export default useCustomerLoyaltyCardMembershipTransactions;
